import { render } from "./TemplateIsoSelection.vue?vue&type=template&id=30857932&scoped=true"
import script from "./TemplateIsoSelection.vue?vue&type=script&lang=js"
export * from "./TemplateIsoSelection.vue?vue&type=script&lang=js"

import "./TemplateIsoSelection.vue?vue&type=style&index=0&id=30857932&lang=less&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30857932"]])

export default __exports__